/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Settings_Sources_DescriptionInputs */

const es_walkthrough_settings_sources_description = /** @type {(inputs: Walkthrough_Settings_Sources_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectá fuentes de datos dinámicas con solo un clic. Estas fuentes se consultan en tiempo real — cuando preguntes algo, Nexy buscará directamente en tus emails, calendarios, contactos y más sin necesidad de ingestar archivos.`)
};

const en_walkthrough_settings_sources_description = /** @type {(inputs: Walkthrough_Settings_Sources_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect dynamic data sources with just one click. These sources are queried in real time — when you ask something, Nexy will search directly in your emails, calendars, contacts, and more without needing to ingest files.`)
};

/**
* | output |
* | --- |
* | "Connect dynamic data sources with just one click. These sources are queried in real time — when you ask something, Nexy will search directly in your emails, ..." |
*
* @param {Walkthrough_Settings_Sources_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_settings_sources_description = /** @type {((inputs?: Walkthrough_Settings_Sources_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Settings_Sources_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_settings_sources_description(inputs)
	return en_walkthrough_settings_sources_description(inputs)
});
export { walkthrough_settings_sources_description as "walkthrough.settings_sources_description" }